import React from 'react';
// import { connect } from 'react-redux'
import Text from './Text';
import Button from './Button';
import Image from './Image';
import ComponentDropArea, {RenderComponentDropArea} from '../ComponentDropArea';
import DnDOverContent from '../common/DnDOverContent'
import { allowed_types_component_menu, allowed_types_component } from './DropContext';

import './ContextMenu_common.css'

// Module actions
// import { setUpdateTargetComponent } from 'store/modules/MessageModule'
// import { updateComponent } from 'store/modules/MessageModule'
// import { setIsDragging } from 'store/modules/DnD'
import DraggableComponent from './DraggableComponent'
import DnDContext from '../DnDContext'
import { DnD_element_type, DnD_element_type_category } from '../common/ConstantValues'
// import { updateComponentIndexPos } from '../store/modules/MessageModule'
import { onDropComponent } from './DropComponentCommonFunctions'

// import { RenderComponentDropArea0 } from './ComponentDropArea0'
// import SpecialComponent from './SpecialComponent';
import Tel from './Tel';
import Addr from './Addr';
import DateComponent from './DateComponent';
import { warn_message_style, message_style_second } from '../common/Common_styles';
// import { setMsgChanges } from '../store/modules/ResponseGenerationModule';

/**
 * 이 컴포넌트는 노말 컴포넌트들의 공통된 로직을 중복하지 않기 위해서 생성됨
 * props의 children은 type이 normal인 컴포넌트가 들어올 수 있음
 */
const SpecialComponentContainer = (props) => {
  // Custom props
  const { attr, onDrop, local_id, message_index, row_index, row_index_detail, component_index, isDragging, index, messageActions } = props
  const { name, value, resource, col, fillRemainCol, components } = props

  // Container props
  const { setIsDragging, setMsgChanges } = props

  // Actions to messages data
  const {
    
  } = messageActions

  // const onOver = (e) => {
  //   e.stopPropagation()
  // }

  /**
   * 메뉴의 컴포넌트 onDrop
   * @param {Object} e 
   */
  const onDrop_component = (e) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!row_index_detail) { // No inspect index 0 case because, index 0 case(first drop area) is parent component responsibility
      setMsgChanges(true) // Set message changes to true
    }
    e = {
      ...e,
      component_index : component_index
    }
    onDrop(e)
  }

  /**
   * 랜더링 된 메시지의 컴포넌트 onDrop (Change position)
   * @param {Object} e 
   */
  const onDrop_dragging_component = (e) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!row_index_detail) { // No inspect index 0 case because, index 0 case(first drop area) is parent component responsibility
      setMsgChanges(true) // Set message changes to true
    }
    const { updateComponentIndexPos } = props
    // const { messageIndex, rowIndex, componentIndex } = e
    onDropComponent(updateComponentIndexPos, e, message_index, row_index, component_index)
  }

  const onShow_menu = (component) => {
    const { setUpdateTargetComponent } = props
    // setUpdateTargetComponent({
    //   message_index: message_index,
    //   row_index: row_index,
    //   component_index: component_index,
    // })
  }

  const onHide_menu = () => {
    const { setUpdateTargetComponent } = props
    setUpdateTargetComponent(null)
  }

  const _updateComponent = (component) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!row_index_detail) { // No inspect index 0 case because, index 0 case(first drop area) is parent component responsibility
      setMsgChanges(true) // Set message changes to true
    }
    const { updateComponent } = props
    updateComponent({
      updateInfo: component,
      indexInfo: {
        messageIndex: message_index,
        rowIndex: row_index,
        componentIndex: component_index,
      }
    })
  }
  /**
   * 컴포넌트 드래그 시작
   */
  const onDraggedStart = () => {
    setIsDragging({
      dragging: true,
      type: null,
    })
  }
  /**
   * 컴포넌트 드래그 종료
   */
  const onDraggedEnd = () => {
    setIsDragging({
      dragging: false,
      type: null,
    })
  }

  const renderingComponent = (attr) => {
    switch(attr) {
      case "TEL":
        return (
          <React.Fragment>
            <DraggableComponentWrap
              messageIndex={message_index}
              rowIndex={row_index}
              componentIndex={component_index}
              onDragStart={onDraggedStart} 
              onDragEnd={onDraggedEnd} 
              cat_type={DnD_element_type_category.REN_ELEM}
              type={DnD_element_type.COMPONENT.SPECIAL.TEL} prefix_type="SPECIAL"
            >
              <Tel
                key={local_id}
                index={component_index}
                id={local_id}
                value={value}
                name={name}
                menuOnShow={onShow_menu}
                menuOnHide={onHide_menu}
                updateComponent={_updateComponent}
                // onOver={onOver}
              />
            </DraggableComponentWrap>
            {
              isDragging ? ( 
                /* Drop area for Change component index position function */
                <RenderComponentDropArea 
                  key={component_index+1}
                  onDrop={onDrop_dragging_component}
                  DnDOverContent={DnDOverContent}
                  overContentArg={overContentArg}
                  allowed_types={allowed_types_component}
                />
              ) : (
                /* Drop area for Add component function */
                <RenderComponentDropArea 
                  key={component_index}
                  onDrop={onDrop_component}
                  DnDOverContent={DnDOverContent}
                  overContentArg={overContentArg}
                  allowed_types={allowed_types_component_menu}
                />
              )
            }
          </React.Fragment>
        )

      case "DATE":
        return (
          <React.Fragment>
            <DraggableComponentWrap
              messageIndex={message_index}
              rowIndex={row_index}
              componentIndex={component_index}
              onDragStart={onDraggedStart} 
              onDragEnd={onDraggedEnd} 
              cat_type={DnD_element_type_category.REN_ELEM}
              type={DnD_element_type.COMPONENT.SPECIAL.DATE} prefix_type="SPECIAL"
            >
              <DateComponent
                key={local_id}
                index={component_index}
                id={local_id}
                name={name}
                value={value}
                menuOnShow={onShow_menu}
                menuOnHide={onHide_menu}
                updateComponent={_updateComponent}
                // onOver={onOver}
              />
            </DraggableComponentWrap>
            {
              isDragging ? ( 
                /* Drop area for Change component index position function */
                <RenderComponentDropArea 
                  key={component_index+1}
                  onDrop={onDrop_dragging_component}
                  DnDOverContent={DnDOverContent}
                  overContentArg={overContentArg}
                  allowed_types={allowed_types_component}
                />
              ) : (
                /* Drop area for Add component function */
                <RenderComponentDropArea 
                  key={component_index}
                  onDrop={onDrop_component}
                  DnDOverContent={DnDOverContent}
                  overContentArg={overContentArg}
                  allowed_types={allowed_types_component_menu}
                />
              )
            }
          </React.Fragment>
        )

      case "ADDR":
          return (
            <React.Fragment>
              <DraggableComponentWrap
                messageIndex={message_index}
                rowIndex={row_index}
                componentIndex={component_index}
                onDragStart={onDraggedStart} 
                onDragEnd={onDraggedEnd} 
                cat_type={DnD_element_type_category.REN_ELEM}
                type={DnD_element_type.COMPONENT.SPECIAL.DATE} prefix_type="SPECIAL"
              >
                <Addr
                  key={local_id}
                  index={component_index}
                  id={local_id}
                  name={name}
                  value={value}
                  resource={resource}
                  menuOnShow={onShow_menu}
                  menuOnHide={onHide_menu}
                  updateComponent={_updateComponent}
                  // onOver={onOver}
                />
              </DraggableComponentWrap>
              {
                isDragging ? (
                  /* Drop area for Change component index position function */
                  <RenderComponentDropArea
                    key={component_index+1}
                    onDrop={onDrop_dragging_component}
                    DnDOverContent={DnDOverContent}
                    overContentArg={overContentArg}
                    allowed_types={allowed_types_component}
                  />
                ) : (
                  /* Drop area for Add component function */
                  <RenderComponentDropArea 
                    key={component_index}
                    onDrop={onDrop_component}
                    DnDOverContent={DnDOverContent}
                    overContentArg={overContentArg}
                    allowed_types={allowed_types_component_menu}
                  />
                )
              }
            </React.Fragment>
          )

      default:
        return (
          <p> Can not find any match type (if it persist, contact to admin) </p>
        )

    }
  }

  return (
    renderingComponent(attr)
  )
}

const overContentArg = {
  minHeight: 15,
  opacity: 0.3,
}
const renderComponentDropArea = (onDrop) => {
  return (
    <ComponentDropArea
      onDrop={onDrop}
      overContent={DnDOverContent}
      overContentArg={overContentArg}
      acceptTypes={allowed_types_component_menu}
    />
  )
}
const DraggableComponentWrap = (props) => {
  return (
    <DnDContext>
      <DraggableComponent dragHandle={DragHandle()} {...props}>
        {props.children}
      </DraggableComponent>
    </DnDContext>
  )
}
const DragHandle = () => {
  return (
    <div style={{width:'100%', height:'100%',border: '3px solid #1085c5',backgroundColor:'#1085c5', borderRadius: 2.5}}>
    </div>
  ) 
}

const mapStateToProps = (state) => ({
  isDragging: state.DnD.isDragging,
})

const mapDispatchToProps = (dispatch) => ({
  // setUpdateTargetComponent: (arg) => {dispatch(setUpdateTargetComponent(arg))},
  // updateComponent: (arg) => {dispatch(updateComponent(arg))},
  // setIsDragging: (arg) => {dispatch(setIsDragging(arg))},
  // updateComponentIndexPos: (arg) => {dispatch(updateComponentIndexPos(arg))},
  // setMsgChanges: (value) => {dispatch(setMsgChanges(value))},
})

/**
 * No description rendering for special components
 */
export const noDescContent = () => (
  <div style={{textAlign:"left"}}>
    <h4 style={warn_message_style}> 설명이 입력되지 않음 </h4>
    <p style={{...message_style_second, lineHeight:'18px'}}> 입력되지 않았을 경우 아무런 텍스트도 표시되지 않습니다. </p>
  </div>
)

export default SpecialComponentContainer